import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { ContentfulSys } from '../../types';
import { RelatedArticleTitle } from './RelatedArticleTitle';

type RelatedArticleItem = {
  sys: ContentfulSys;
};

type RelatedArticlesProps = {
  relatedArticles: RelatedArticleItem[] | undefined;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    relatedArticles: {
      color: theme.palette.primary.main,
      margin: theme.spacing(2, 2, 0),
      paddingLeft: 0,
      '& li': {
        marginBottom: theme.spacing(1),
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
  }),
);

export const RelatedArticles: React.FC<RelatedArticlesProps> = ({ relatedArticles }) => {
  const classes = useStyles();

  if (!relatedArticles || relatedArticles.length === 0) {
    return null;
  }

  return (
    <Grid item sm={12}>
      <Typography color="primary" variant="h2">
        Related Articles
      </Typography>
      <ul className={classes.relatedArticles}>
        {relatedArticles.map((relatedArticle) => (
          <li key={relatedArticle.sys.id}>
            <Typography variant="body1">
              <RelatedArticleTitle articleId={relatedArticle.sys.id} style={{ textDecoration: 'none' }} />
            </Typography>
          </li>
        ))}
      </ul>
    </Grid>
  );
};
